"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KSLegacyService = void 0;
const config_1 = require("../config/config");
const util_1 = require("./util");
const PATH_V1 = '/kslegacy/api/v1';
class KSLegacyService {
    static async getRewardHistory(legacyUserId, request) {
        const { page, size } = request;
        const requestParams = [`page=${page || 0}`, `size=${size || config_1.MAX_SAFE_INTEGER}`];
        const url = `${PATH_V1}/rewardHistory/${legacyUserId}?${requestParams.join('&')}`;
        try {
            return await (0, util_1.formatResponse)(url, requestParams);
        }
        catch (error) {
            throw error;
        }
    }
    static async getActivityHistory(legacyUserId, request) {
        const { page, size } = request;
        const requestParams = [`page=${page || 0}`, `size=${size || config_1.MAX_SAFE_INTEGER}`];
        const url = `${PATH_V1}/activityHistory/${legacyUserId}?${requestParams.join('&')}`;
        try {
            return await (0, util_1.formatResponse)(url, requestParams);
        }
        catch (error) {
            throw error;
        }
    }
}
exports.KSLegacyService = KSLegacyService;
//# sourceMappingURL=kslegacy-service.js.map